import { pathOr, } from 'ramda';

export const preloaderVisibilitySelector = pathOr('true', [ 'ui', 'preloader', 'visible', ]);
